module.exports = __webpack_public_path__ + "img/Picture30.490c379d.png";